import { z } from "zod";

/**
 * One person the office chose to sync: their Personio id, and the member to link them to — or
 * `null` to have the server create, or take over, the account the person's Personio email
 * address names.
 */
export const personioSyncItemSchema = z.object({
	personId: z.string().min(1),
	userId: z.string().min(1).nullable(),
});

/**
 * The Personio sync the office confirmed. Only ids travel: names and email addresses are read
 * from Personio again on the server, so nothing the browser sends becomes an account's identity.
 */
export const postPersonioAutoIntegrationSchema = z.object({
	items: z.array(personioSyncItemSchema).min(1).max(500),
});

export type PersonioSyncItemSchema = z.infer<typeof personioSyncItemSchema>;
export type PostPersonioAutoIntegrationSchema = z.infer<typeof postPersonioAutoIntegrationSchema>;
